import React from 'react'
import clsx from 'clsx'
import { StarIcon } from '../../icons/StarIcon'

export const Tag = ({ label, white = false, featured = false }) => {

    return (
        <div className='pr-24 max-w-max box-border'>
            <div
                className={
                    clsx(
                        white ? 'bg-white text-blue before:bg-white' : 'bg-blue before:bg-blue text-white',
                        'relative block p-2 pr-2 md:p-5 md:pr-5 text-10 md:text-12 uppercase font-medium border-2 border-blue border-r-0',
                        'before:block before:p-5 before:absolute before:-top-2 before:-right-20 before:-skew-x-15 before:h-[calc(100%+4px)] before:w-28 before:border-2 before:border-blue before:border-l-0',
                    )
                }
            >
                <span className='relative z-1'>{label}</span>
                {featured && (<StarIcon className='absolute -right-28 top-1/2 -translate-y-1/2 translate-x-2 text-20' />)}
            </div>
        </div>
    )
}
